/**
 * Sdílené buňky výpisu objednávek — OrdersList a blok Objednávky v detailu zákazníka.
 * Styly jsou v modules/OrdersList.css.
 */
import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import '../modules/OrdersList.css';

// Global state color definitions for booking states
export const STATE_COLORS = {
  CONFIRMED: { bg: '#d1e7dd', color: '#0a5236', label: 'Potvrzení' },
  RESERVATION: { bg: '#fff3cd', color: '#856404', label: 'Rezervace' },
  CANCELED: { bg: '#f8d7da', color: '#842029', label: 'Storno' },
};

export const getStateStyle = (stateId) => {
  return STATE_COLORS[stateId] || { bg: '#e9ecef', color: '#495057', label: stateId || '—' };
};

/**
 * Format price for Czech locale: 1234567.89 → "1 234 567,89"
 */
export const formatPrice = (value) => {
  if (value === null || value === undefined || value === '') return '—';
  const num = parseFloat(value);
  if (isNaN(num)) return '—';
  return num.toLocaleString('cs-CZ', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

/**
 * Format date: "2024-01-15" → "15.01.2024"
 */
export const formatDate = (dateStr) => {
  if (!dateStr) return '—';
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}.${month}.${year}`;
};

/**
 * Multi-item cell: shows first item name + "více N" with popover for the rest
 */
export function MultiItemCell({ items, nameKey = 'name', extraKey = null }) {
  if (!items || items.length === 0) return <span className="text-muted">—</span>;

  if (items.length === 1) {
    return <span>{items[0][nameKey]}</span>;
  }

  const remaining = items.slice(1);
  const popover = (
    <Popover id={`popover-${Math.random()}`} className="popover-projects">
      <Popover.Body className="p-0">
        {remaining.map((item, idx) => (
          <div key={idx} className="pop-project-row">
            <div className="pop-project-name">{item[nameKey]}</div>
            {extraKey && item[extraKey] && (
              <div className="pop-project-sub">{item[extraKey]}</div>
            )}
          </div>
        ))}
      </Popover.Body>
    </Popover>
  );

  return (
    <span>
      <span className="me-1">{items[0][nameKey]}</span>
      <OverlayTrigger trigger={["hover", "focus"]} placement="bottom" overlay={popover}>
        <span className="multi-badge" role="button">+{remaining.length}</span>
      </OverlayTrigger>
    </span>
  );
}

/**
 * Ratecard items cell: shows first item name + "více N" with popover for the rest
 */
export function RatecardItemsCell({ items }) {
  if (!items || items.length === 0) return <span className="text-muted">—</span>;

  if (items.length === 1) {
    return <span>{items[0].ratecard_item_name}</span>;
  }

  const remaining = items.slice(1);
  const popover = (
    <Popover id={`popover-rc-${Math.random()}`} className="popover-projects">
      <Popover.Body className="p-0">
        {remaining.map((item, idx) => (
          <div key={idx} className="pop-project-row">
            <div className="pop-project-name">{item.ratecard_item_name}</div>
          </div>
        ))}
      </Popover.Body>
    </Popover>
  );

  return (
    <span>
      <span className="me-1">{items[0].ratecard_item_name}</span>
      <OverlayTrigger trigger={["hover", "focus"]} placement="bottom" overlay={popover}>
        <span className="multi-badge" role="button">+{remaining.length}</span>
      </OverlayTrigger>
    </span>
  );
}
